import React from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../lib/ui/select'
import { useInterestKeys } from '~/components/ActionPlan/InterestKeys'
import { useTranslation } from '~/hooks/useTranslation'
import { useActionPlan } from './ActionPlanProvider'

const SetGoalForm = ({ setNewGoal }) => {
  const { t } = useTranslation('SetGoalForm')
  const { goalKey } = useActionPlan()
  const interestKeys = useInterestKeys()

  return (
    <div className="flex flex-col gap-4 px-6 pt-2">
      <div>{t('please_select_your_goal')}</div>
      <Select
        onValueChange={(v) => setNewGoal(v)}
        defaultValue={goalKey || undefined}
      >
        <SelectTrigger
          className="sm:w-4/6"
          aria-label={t('please_select_your_goal')}
        >
          <SelectValue placeholder={t('select_an_option')} />
        </SelectTrigger>
        <SelectContent>
          {Object.entries(interestKeys).map(([key, value]) => (
            <SelectItem key={key} value={key}>
              {value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
export default SetGoalForm
